import { Jumbotron } from 'react-bootstrap'
import errorImage from './../img/payment_error.svg'

const errorPrefix = 'Error: Belangrijke boodschap voor de mandatarissen met hoofdinschrijving bij Balie'
const balieErrorText = {
  'antwerpen-a': 'Sinds 01/01/2023 is het niet langer mogelijk om mandaten toegekend vanaf 01/01/2023 via dit platform te verzekeren.',
  'antwerpen-b': 'Vanaf 01/04/2023 is het niet langer mogelijk zijn mandaten via dit platform te verzekeren, ook niet als ze toegekend werden voor 01/01/2023.',
  'brussel-a': 'Sinds 01/01/2025 is het niet langer mogelijk om mandaten toegekend vanaf 01/01/2025 via dit platform te verzekeren.',
  'brussel-b': 'Vanaf 01/04/2025 is het niet langer mogelijk om mandaten via dit platform te verzekeren, ook niet als ze toegekend werden voor 01/01/2025.'
}

const BalieError = (props) => {
  return (
    <Jumbotron className='text-center'>
      <img className='mb-4' src={errorImage} alt='error' />
      <p>{props.hasCase ? '' : `${errorPrefix} ${props.variant.includes('antwerpen') ? 'Antwerpen' : 'Brussel'}: `}{balieErrorText[props.variant]}</p>
      <p>Voor vragen kan u contact opnemen per mail via het adres <a href="mailto:spccb@vanbreda.be">spccb@vanbreda.be</a>.</p>
    </Jumbotron>
  )
}

export default BalieError
